export default {
  "size-border-radius-small": {
    "value": "0.125em",
    "filePath": "src/tokens/size/border.json",
    "isSource": true,
    "original": {
      "value": "0.125em"
    },
    "name": "size-border-radius-small",
    "attributes": {
      "category": "size",
      "type": "border",
      "item": "radius",
      "subitem": "small"
    },
    "path": [
      "size",
      "border",
      "radius",
      "small"
    ]
  },
  "size-border-radius-medium": {
    "value": "0.25em",
    "filePath": "src/tokens/size/border.json",
    "isSource": true,
    "original": {
      "value": "0.25em"
    },
    "name": "size-border-radius-medium",
    "attributes": {
      "category": "size",
      "type": "border",
      "item": "radius",
      "subitem": "medium"
    },
    "path": [
      "size",
      "border",
      "radius",
      "medium"
    ]
  },
  "size-border-radius-large": {
    "value": "0.5em",
    "filePath": "src/tokens/size/border.json",
    "isSource": true,
    "original": {
      "value": "0.5em"
    },
    "name": "size-border-radius-large",
    "attributes": {
      "category": "size",
      "type": "border",
      "item": "radius",
      "subitem": "large"
    },
    "path": [
      "size",
      "border",
      "radius",
      "large"
    ]
  },
  "size-border-radius-card-contained": {
    "value": "0.5em",
    "filePath": "src/tokens/size/border.json",
    "isSource": true,
    "original": {
      "value": "{size.border.radius.large.value}"
    },
    "name": "size-border-radius-card-contained",
    "attributes": {
      "category": "size",
      "type": "border",
      "item": "radius",
      "subitem": "card-contained"
    },
    "path": [
      "size",
      "border",
      "radius",
      "card-contained"
    ]
  },
  "size-border-radius-full": {
    "value": "9999px",
    "comment": "A value of 50% would be more intuitive, but results in unexpectedly oblong rounding for non-square shapes. We use `px` to save the browser the trouble of recalculating the stupidly large value.",
    "filePath": "src/tokens/size/border.json",
    "isSource": true,
    "original": {
      "value": "9999px",
      "comment": "A value of 50% would be more intuitive, but results in unexpectedly oblong rounding for non-square shapes. We use `px` to save the browser the trouble of recalculating the stupidly large value."
    },
    "name": "size-border-radius-full",
    "attributes": {
      "category": "size",
      "type": "border",
      "item": "radius",
      "subitem": "full"
    },
    "path": [
      "size",
      "border",
      "radius",
      "full"
    ]
  },
  "size-border-width-blockquote": {
    "value": "0.125rem",
    "filePath": "src/tokens/size/border.json",
    "isSource": true,
    "original": {
      "value": "{size.edge.medium.value}"
    },
    "name": "size-border-width-blockquote",
    "attributes": {
      "category": "size",
      "type": "border",
      "item": "width",
      "subitem": "blockquote"
    },
    "path": [
      "size",
      "border",
      "width",
      "blockquote"
    ]
  },
  "size-breakpoint-xs": {
    "value": "20em",
    "filePath": "src/tokens/size/breakpoint.json",
    "isSource": true,
    "original": {
      "value": "{size.xs.value}"
    },
    "name": "size-breakpoint-xs",
    "attributes": {
      "category": "size",
      "type": "breakpoint",
      "item": "xs"
    },
    "path": [
      "size",
      "breakpoint",
      "xs"
    ]
  },
  "size-breakpoint-s": {
    "value": "30em",
    "filePath": "src/tokens/size/breakpoint.json",
    "isSource": true,
    "original": {
      "value": "{size.s.value}"
    },
    "name": "size-breakpoint-s",
    "attributes": {
      "category": "size",
      "type": "breakpoint",
      "item": "s"
    },
    "path": [
      "size",
      "breakpoint",
      "s"
    ]
  },
  "size-breakpoint-m": {
    "value": "40em",
    "filePath": "src/tokens/size/breakpoint.json",
    "isSource": true,
    "original": {
      "value": "{size.m.value}"
    },
    "name": "size-breakpoint-m",
    "attributes": {
      "category": "size",
      "type": "breakpoint",
      "item": "m"
    },
    "path": [
      "size",
      "breakpoint",
      "m"
    ]
  },
  "size-breakpoint-l": {
    "value": "60em",
    "filePath": "src/tokens/size/breakpoint.json",
    "isSource": true,
    "original": {
      "value": "{size.l.value}"
    },
    "name": "size-breakpoint-l",
    "attributes": {
      "category": "size",
      "type": "breakpoint",
      "item": "l"
    },
    "path": [
      "size",
      "breakpoint",
      "l"
    ]
  },
  "size-breakpoint-xl": {
    "value": "72em",
    "filePath": "src/tokens/size/breakpoint.json",
    "isSource": true,
    "original": {
      "value": "{size.xl.value}"
    },
    "name": "size-breakpoint-xl",
    "attributes": {
      "category": "size",
      "type": "breakpoint",
      "item": "xl"
    },
    "path": [
      "size",
      "breakpoint",
      "xl"
    ]
  },
  "size-breakpoint-xxl": {
    "value": "84em",
    "filePath": "src/tokens/size/breakpoint.json",
    "isSource": true,
    "original": {
      "value": "{size.xxl.value}"
    },
    "name": "size-breakpoint-xxl",
    "attributes": {
      "category": "size",
      "type": "breakpoint",
      "item": "xxl"
    },
    "path": [
      "size",
      "breakpoint",
      "xxl"
    ]
  },
  "size-breakpoint-xxxl": {
    "value": "96em",
    "filePath": "src/tokens/size/breakpoint.json",
    "isSource": true,
    "original": {
      "value": "{size.xxxl.value}"
    },
    "name": "size-breakpoint-xxxl",
    "attributes": {
      "category": "size",
      "type": "breakpoint",
      "item": "xxxl"
    },
    "path": [
      "size",
      "breakpoint",
      "xxxl"
    ]
  },
  "size-edge-small": {
    "value": "0.0625rem",
    "filePath": "src/tokens/size/edge.json",
    "isSource": true,
    "original": {
      "value": "0.0625rem"
    },
    "name": "size-edge-small",
    "attributes": {
      "category": "size",
      "type": "edge",
      "item": "small"
    },
    "path": [
      "size",
      "edge",
      "small"
    ]
  },
  "size-edge-medium": {
    "value": "0.125rem",
    "filePath": "src/tokens/size/edge.json",
    "isSource": true,
    "original": {
      "value": "0.125rem"
    },
    "name": "size-edge-medium",
    "attributes": {
      "category": "size",
      "type": "edge",
      "item": "medium"
    },
    "path": [
      "size",
      "edge",
      "medium"
    ]
  },
  "size-edge-large": {
    "value": "0.25rem",
    "filePath": "src/tokens/size/edge.json",
    "isSource": true,
    "original": {
      "value": "0.25rem"
    },
    "name": "size-edge-large",
    "attributes": {
      "category": "size",
      "type": "edge",
      "item": "large"
    },
    "path": [
      "size",
      "edge",
      "large"
    ]
  },
  "size-edge-control": {
    "value": "0.125rem",
    "filePath": "src/tokens/size/edge.json",
    "isSource": true,
    "original": {
      "value": "{size.edge.medium.value}"
    },
    "name": "size-edge-control",
    "attributes": {
      "category": "size",
      "type": "edge",
      "item": "control"
    },
    "path": [
      "size",
      "edge",
      "control"
    ]
  },
  "size-font-big": {
    "value": "1.25em",
    "comment": "Slightly larger than normal. Good for short introductory sections or important actions.",
    "filePath": "src/tokens/size/font.js",
    "isSource": true,
    "original": {
      "value": "1.25em",
      "comment": "Slightly larger than normal. Good for short introductory sections or important actions."
    },
    "name": "size-font-big",
    "attributes": {
      "category": "size",
      "type": "font",
      "item": "big"
    },
    "path": [
      "size",
      "font",
      "big"
    ]
  },
  "size-font-small": {
    "value": "0.8em",
    "comment": "Slightly smaller than usual. Good for badges, captions or other space-constrained bits of copy.",
    "filePath": "src/tokens/size/font.js",
    "isSource": true,
    "original": {
      "value": "0.8em",
      "comment": "Slightly smaller than usual. Good for badges, captions or other space-constrained bits of copy."
    },
    "name": "size-font-small",
    "attributes": {
      "category": "size",
      "type": "font",
      "item": "small"
    },
    "path": [
      "size",
      "font",
      "small"
    ]
  },
  "size-font-heading-n2-max": {
    "value": "3.814697265625em",
    "comment": "Maximum fluid size for heading level -2.",
    "filePath": "src/tokens/size/heading.js",
    "isSource": true,
    "original": {
      "value": "3.814697265625em",
      "comment": "Maximum fluid size for heading level -2."
    },
    "name": "size-font-heading-n2-max",
    "attributes": {
      "category": "size",
      "type": "font",
      "item": "heading_n2",
      "subitem": "max"
    },
    "path": [
      "size",
      "font",
      "heading_n2",
      "max"
    ]
  },
  "size-font-heading-n2-min": {
    "value": "3.0517578125em",
    "comment": "Minimum fluid size for heading level -2.",
    "filePath": "src/tokens/size/heading.js",
    "isSource": true,
    "original": {
      "value": "3.0517578125em",
      "comment": "Minimum fluid size for heading level -2."
    },
    "name": "size-font-heading-n2-min",
    "attributes": {
      "category": "size",
      "type": "font",
      "item": "heading_n2",
      "subitem": "min"
    },
    "path": [
      "size",
      "font",
      "heading_n2",
      "min"
    ]
  },
  "size-font-heading-n1-max": {
    "value": "3.0517578125em",
    "comment": "Maximum fluid size for heading level -1.",
    "filePath": "src/tokens/size/heading.js",
    "isSource": true,
    "original": {
      "value": "3.0517578125em",
      "comment": "Maximum fluid size for heading level -1."
    },
    "name": "size-font-heading-n1-max",
    "attributes": {
      "category": "size",
      "type": "font",
      "item": "heading_n1",
      "subitem": "max"
    },
    "path": [
      "size",
      "font",
      "heading_n1",
      "max"
    ]
  },
  "size-font-heading-n1-min": {
    "value": "2.44140625em",
    "comment": "Minimum fluid size for heading level -1.",
    "filePath": "src/tokens/size/heading.js",
    "isSource": true,
    "original": {
      "value": "2.44140625em",
      "comment": "Minimum fluid size for heading level -1."
    },
    "name": "size-font-heading-n1-min",
    "attributes": {
      "category": "size",
      "type": "font",
      "item": "heading_n1",
      "subitem": "min"
    },
    "path": [
      "size",
      "font",
      "heading_n1",
      "min"
    ]
  },
  "size-font-heading-0-max": {
    "value": "2.44140625em",
    "comment": "Maximum fluid size for heading level 0.",
    "filePath": "src/tokens/size/heading.js",
    "isSource": true,
    "original": {
      "value": "2.44140625em",
      "comment": "Maximum fluid size for heading level 0."
    },
    "name": "size-font-heading-0-max",
    "attributes": {
      "category": "size",
      "type": "font",
      "item": "heading_0",
      "subitem": "max"
    },
    "path": [
      "size",
      "font",
      "heading_0",
      "max"
    ]
  },
  "size-font-heading-0-min": {
    "value": "1.953125em",
    "comment": "Minimum fluid size for heading level 0.",
    "filePath": "src/tokens/size/heading.js",
    "isSource": true,
    "original": {
      "value": "1.953125em",
      "comment": "Minimum fluid size for heading level 0."
    },
    "name": "size-font-heading-0-min",
    "attributes": {
      "category": "size",
      "type": "font",
      "item": "heading_0",
      "subitem": "min"
    },
    "path": [
      "size",
      "font",
      "heading_0",
      "min"
    ]
  },
  "size-font-heading-1-max": {
    "value": "1.953125em",
    "comment": "Maximum fluid size for heading level 1.",
    "filePath": "src/tokens/size/heading.js",
    "isSource": true,
    "original": {
      "value": "1.953125em",
      "comment": "Maximum fluid size for heading level 1."
    },
    "name": "size-font-heading-1-max",
    "attributes": {
      "category": "size",
      "type": "font",
      "item": "heading_1",
      "subitem": "max"
    },
    "path": [
      "size",
      "font",
      "heading_1",
      "max"
    ]
  },
  "size-font-heading-1-min": {
    "value": "1.5625em",
    "comment": "Minimum fluid size for heading level 1.",
    "filePath": "src/tokens/size/heading.js",
    "isSource": true,
    "original": {
      "value": "1.5625em",
      "comment": "Minimum fluid size for heading level 1."
    },
    "name": "size-font-heading-1-min",
    "attributes": {
      "category": "size",
      "type": "font",
      "item": "heading_1",
      "subitem": "min"
    },
    "path": [
      "size",
      "font",
      "heading_1",
      "min"
    ]
  },
  "size-font-heading-2-max": {
    "value": "1.5625em",
    "comment": "Maximum fluid size for heading level 2.",
    "filePath": "src/tokens/size/heading.js",
    "isSource": true,
    "original": {
      "value": "1.5625em",
      "comment": "Maximum fluid size for heading level 2."
    },
    "name": "size-font-heading-2-max",
    "attributes": {
      "category": "size",
      "type": "font",
      "item": "heading_2",
      "subitem": "max"
    },
    "path": [
      "size",
      "font",
      "heading_2",
      "max"
    ]
  },
  "size-font-heading-2-min": {
    "value": "1.25em",
    "comment": "Minimum fluid size for heading level 2.",
    "filePath": "src/tokens/size/heading.js",
    "isSource": true,
    "original": {
      "value": "1.25em",
      "comment": "Minimum fluid size for heading level 2."
    },
    "name": "size-font-heading-2-min",
    "attributes": {
      "category": "size",
      "type": "font",
      "item": "heading_2",
      "subitem": "min"
    },
    "path": [
      "size",
      "font",
      "heading_2",
      "min"
    ]
  },
  "size-font-heading-3-max": {
    "value": "1.25em",
    "comment": "Maximum fluid size for heading level 3.",
    "filePath": "src/tokens/size/heading.js",
    "isSource": true,
    "original": {
      "value": "1.25em",
      "comment": "Maximum fluid size for heading level 3."
    },
    "name": "size-font-heading-3-max",
    "attributes": {
      "category": "size",
      "type": "font",
      "item": "heading_3",
      "subitem": "max"
    },
    "path": [
      "size",
      "font",
      "heading_3",
      "max"
    ]
  },
  "size-font-heading-3-min": {
    "value": "1em",
    "comment": "Minimum fluid size for heading level 3.",
    "filePath": "src/tokens/size/heading.js",
    "isSource": true,
    "original": {
      "value": "1em",
      "comment": "Minimum fluid size for heading level 3."
    },
    "name": "size-font-heading-3-min",
    "attributes": {
      "category": "size",
      "type": "font",
      "item": "heading_3",
      "subitem": "min"
    },
    "path": [
      "size",
      "font",
      "heading_3",
      "min"
    ]
  },
  "size-max-width-media-object": {
    "value": "7em",
    "filePath": "src/tokens/size/max-width.json",
    "isSource": true,
    "original": {
      "value": "7em"
    },
    "name": "size-max-width-media-object",
    "attributes": {
      "category": "size",
      "type": "max_width",
      "item": "media_object"
    },
    "path": [
      "size",
      "max_width",
      "media_object"
    ]
  },
  "size-max-width-prose": {
    "value": "40em",
    "filePath": "src/tokens/size/max-width.json",
    "isSource": true,
    "original": {
      "value": "{size.m.value}"
    },
    "name": "size-max-width-prose",
    "attributes": {
      "category": "size",
      "type": "max_width",
      "item": "prose"
    },
    "path": [
      "size",
      "max_width",
      "prose"
    ]
  },
  "size-max-width-spread": {
    "value": "72em",
    "filePath": "src/tokens/size/max-width.json",
    "isSource": true,
    "original": {
      "value": "{size.xl.value}"
    },
    "name": "size-max-width-spread",
    "attributes": {
      "category": "size",
      "type": "max_width",
      "item": "spread"
    },
    "path": [
      "size",
      "max_width",
      "spread"
    ]
  },
  "size-padding-control-horizontal": {
    "value": "1.25em",
    "filePath": "src/tokens/size/padding.js",
    "isSource": true,
    "original": {
      "value": "1.25em"
    },
    "name": "size-padding-control-horizontal",
    "attributes": {
      "category": "size",
      "type": "padding",
      "item": "control",
      "subitem": "horizontal"
    },
    "path": [
      "size",
      "padding",
      "control",
      "horizontal"
    ]
  },
  "size-padding-control-vertical": {
    "value": "0.40959999999999996em",
    "filePath": "src/tokens/size/padding.js",
    "isSource": true,
    "original": {
      "value": "0.40959999999999996em"
    },
    "name": "size-padding-control-vertical",
    "attributes": {
      "category": "size",
      "type": "padding",
      "item": "control",
      "subitem": "vertical"
    },
    "path": [
      "size",
      "padding",
      "control",
      "vertical"
    ]
  },
  "size-padding-cell-horizontal": {
    "value": "0.512em",
    "comment": "Used for table cells or other repeating content rows.",
    "filePath": "src/tokens/size/padding.js",
    "isSource": true,
    "original": {
      "value": "0.512em",
      "comment": "Used for table cells or other repeating content rows."
    },
    "name": "size-padding-cell-horizontal",
    "attributes": {
      "category": "size",
      "type": "padding",
      "item": "cell",
      "subitem": "horizontal"
    },
    "path": [
      "size",
      "padding",
      "cell",
      "horizontal"
    ]
  },
  "size-padding-cell-vertical": {
    "value": "0.512em",
    "comment": "Used for table cells or other repeating content rows.",
    "filePath": "src/tokens/size/padding.js",
    "isSource": true,
    "original": {
      "value": "0.512em",
      "comment": "Used for table cells or other repeating content rows."
    },
    "name": "size-padding-cell-vertical",
    "attributes": {
      "category": "size",
      "type": "padding",
      "item": "cell",
      "subitem": "vertical"
    },
    "path": [
      "size",
      "padding",
      "cell",
      "vertical"
    ]
  },
  "size-padding-container-horizontal-min": {
    "value": "1.25rem",
    "comment": "Minimum inline (horizontal) fluid padding for container objects.",
    "filePath": "src/tokens/size/padding.js",
    "isSource": true,
    "original": {
      "value": "1.25rem",
      "comment": "Minimum inline (horizontal) fluid padding for container objects."
    },
    "name": "size-padding-container-horizontal-min",
    "attributes": {
      "category": "size",
      "type": "padding",
      "item": "container",
      "subitem": "horizontal",
      "state": "min"
    },
    "path": [
      "size",
      "padding",
      "container",
      "horizontal",
      "min"
    ]
  },
  "size-padding-container-horizontal-max": {
    "value": "3.0517578125rem",
    "comment": "Maximum inline (horizontal) padding for container objects.",
    "filePath": "src/tokens/size/padding.js",
    "isSource": true,
    "original": {
      "value": "3.0517578125rem",
      "comment": "Maximum inline (horizontal) padding for container objects."
    },
    "name": "size-padding-container-horizontal-max",
    "attributes": {
      "category": "size",
      "type": "padding",
      "item": "container",
      "subitem": "horizontal",
      "state": "max"
    },
    "path": [
      "size",
      "padding",
      "container",
      "horizontal",
      "max"
    ]
  },
  "size-padding-container-vertical-min": {
    "value": "1.953125rem",
    "comment": "Minimum block (vertical) fluid padding for container objects.",
    "filePath": "src/tokens/size/padding.js",
    "isSource": true,
    "original": {
      "value": "1.953125rem",
      "comment": "Minimum block (vertical) fluid padding for container objects."
    },
    "name": "size-padding-container-vertical-min",
    "attributes": {
      "category": "size",
      "type": "padding",
      "item": "container",
      "subitem": "vertical",
      "state": "min"
    },
    "path": [
      "size",
      "padding",
      "container",
      "vertical",
      "min"
    ]
  },
  "size-padding-container-vertical-max": {
    "value": "3.814697265625rem",
    "comment": "Maximum block (vertical) padding for container objects.",
    "filePath": "src/tokens/size/padding.js",
    "isSource": true,
    "original": {
      "value": "3.814697265625rem",
      "comment": "Maximum block (vertical) padding for container objects."
    },
    "name": "size-padding-container-vertical-max",
    "attributes": {
      "category": "size",
      "type": "padding",
      "item": "container",
      "subitem": "vertical",
      "state": "max"
    },
    "path": [
      "size",
      "padding",
      "container",
      "vertical",
      "max"
    ]
  },
  "size-rhythm-compact": {
    "value": "0.262144em",
    "filePath": "src/tokens/size/rhythm.js",
    "isSource": true,
    "original": {
      "value": "0.262144em"
    },
    "name": "size-rhythm-compact",
    "attributes": {
      "category": "size",
      "type": "rhythm",
      "item": "compact"
    },
    "path": [
      "size",
      "rhythm",
      "compact"
    ]
  },
  "size-rhythm-condensed": {
    "value": "0.8em",
    "filePath": "src/tokens/size/rhythm.js",
    "isSource": true,
    "original": {
      "value": "0.8em"
    },
    "name": "size-rhythm-condensed",
    "attributes": {
      "category": "size",
      "type": "rhythm",
      "item": "condensed"
    },
    "path": [
      "size",
      "rhythm",
      "condensed"
    ]
  },
  "size-rhythm-default": {
    "value": "1.25em",
    "filePath": "src/tokens/size/rhythm.js",
    "isSource": true,
    "original": {
      "value": "1.25em"
    },
    "name": "size-rhythm-default",
    "attributes": {
      "category": "size",
      "type": "rhythm",
      "item": "default"
    },
    "path": [
      "size",
      "rhythm",
      "default"
    ]
  },
  "size-rhythm-default-rem": {
    "value": "1.25rem",
    "filePath": "src/tokens/size/rhythm.js",
    "isSource": true,
    "original": {
      "value": "1.25rem"
    },
    "name": "size-rhythm-default-rem",
    "attributes": {
      "category": "size",
      "type": "rhythm",
      "item": "default_rem"
    },
    "path": [
      "size",
      "rhythm",
      "default_rem"
    ]
  },
  "size-rhythm-generous": {
    "value": "1.953125em",
    "filePath": "src/tokens/size/rhythm.js",
    "isSource": true,
    "original": {
      "value": "1.953125em"
    },
    "name": "size-rhythm-generous",
    "attributes": {
      "category": "size",
      "type": "rhythm",
      "item": "generous"
    },
    "path": [
      "size",
      "rhythm",
      "generous"
    ]
  },
  "size-xs": {
    "value": "20em",
    "filePath": "src/tokens/size/shirts.json",
    "isSource": true,
    "original": {
      "value": "20em"
    },
    "name": "size-xs",
    "attributes": {
      "category": "size",
      "type": "xs"
    },
    "path": [
      "size",
      "xs"
    ]
  },
  "size-s": {
    "value": "30em",
    "filePath": "src/tokens/size/shirts.json",
    "isSource": true,
    "original": {
      "value": "30em"
    },
    "name": "size-s",
    "attributes": {
      "category": "size",
      "type": "s"
    },
    "path": [
      "size",
      "s"
    ]
  },
  "size-m": {
    "value": "40em",
    "filePath": "src/tokens/size/shirts.json",
    "isSource": true,
    "original": {
      "value": "40em"
    },
    "name": "size-m",
    "attributes": {
      "category": "size",
      "type": "m"
    },
    "path": [
      "size",
      "m"
    ]
  },
  "size-l": {
    "value": "60em",
    "filePath": "src/tokens/size/shirts.json",
    "isSource": true,
    "original": {
      "value": "60em"
    },
    "name": "size-l",
    "attributes": {
      "category": "size",
      "type": "l"
    },
    "path": [
      "size",
      "l"
    ]
  },
  "size-xl": {
    "value": "72em",
    "filePath": "src/tokens/size/shirts.json",
    "isSource": true,
    "original": {
      "value": "72em"
    },
    "name": "size-xl",
    "attributes": {
      "category": "size",
      "type": "xl"
    },
    "path": [
      "size",
      "xl"
    ]
  },
  "size-xxl": {
    "value": "84em",
    "filePath": "src/tokens/size/shirts.json",
    "isSource": true,
    "original": {
      "value": "84em"
    },
    "name": "size-xxl",
    "attributes": {
      "category": "size",
      "type": "xxl"
    },
    "path": [
      "size",
      "xxl"
    ]
  },
  "size-xxxl": {
    "value": "96em",
    "filePath": "src/tokens/size/shirts.json",
    "isSource": true,
    "original": {
      "value": "96em"
    },
    "name": "size-xxxl",
    "attributes": {
      "category": "size",
      "type": "xxxl"
    },
    "path": [
      "size",
      "xxxl"
    ]
  },
  "size-height-control-default": {
    "value": "2.44140625em",
    "filePath": "src/tokens/size/sizing.js",
    "isSource": true,
    "original": {
      "value": "2.44140625em"
    },
    "name": "size-height-control-default",
    "attributes": {
      "category": "size",
      "type": "height",
      "item": "control",
      "subitem": "default"
    },
    "path": [
      "size",
      "height",
      "control",
      "default"
    ]
  },
  "size-height-control-multiline": {
    "value": "3.814697265625em",
    "filePath": "src/tokens/size/sizing.js",
    "isSource": true,
    "original": {
      "value": "3.814697265625em"
    },
    "name": "size-height-control-multiline",
    "attributes": {
      "category": "size",
      "type": "height",
      "item": "control",
      "subitem": "multiline"
    },
    "path": [
      "size",
      "height",
      "control",
      "multiline"
    ]
  },
  "size-icon-default": {
    "value": "1em",
    "comment": "The default icon size.",
    "filePath": "src/tokens/size/sizing.js",
    "isSource": true,
    "original": {
      "value": "1em",
      "comment": "The default icon size."
    },
    "name": "size-icon-default",
    "attributes": {
      "category": "size",
      "type": "icon",
      "item": "default"
    },
    "path": [
      "size",
      "icon",
      "default"
    ]
  },
  "size-icon-medium": {
    "value": "1.25em",
    "comment": "The medium icon size.",
    "filePath": "src/tokens/size/sizing.js",
    "isSource": true,
    "original": {
      "value": "1.25em",
      "comment": "The medium icon size."
    },
    "name": "size-icon-medium",
    "attributes": {
      "category": "size",
      "type": "icon",
      "item": "medium"
    },
    "path": [
      "size",
      "icon",
      "medium"
    ]
  },
  "size-icon-large": {
    "value": "1.5625em",
    "comment": "The large icon size.",
    "filePath": "src/tokens/size/sizing.js",
    "isSource": true,
    "original": {
      "value": "1.5625em",
      "comment": "The large icon size."
    },
    "name": "size-icon-large",
    "attributes": {
      "category": "size",
      "type": "icon",
      "item": "large"
    },
    "path": [
      "size",
      "icon",
      "large"
    ]
  },
  "size-width-card-column-min": {
    "value": "16em",
    "comment": "The minimum space to display a default card in a grid.",
    "filePath": "src/tokens/size/sizing.js",
    "isSource": true,
    "original": {
      "value": "16em",
      "comment": "The minimum space to display a default card in a grid."
    },
    "name": "size-width-card-column-min",
    "attributes": {
      "category": "size",
      "type": "width",
      "item": "card_column",
      "subitem": "min"
    },
    "path": [
      "size",
      "width",
      "card_column",
      "min"
    ]
  },
  "size-width-logo-group-item-width": {
    "value": "9em",
    "comment": "The width of individual logos in the logo group.",
    "filePath": "src/tokens/size/sizing.js",
    "isSource": true,
    "original": {
      "value": "9em",
      "comment": "The width of individual logos in the logo group."
    },
    "name": "size-width-logo-group-item-width",
    "attributes": {
      "category": "size",
      "type": "width",
      "item": "logo_group",
      "subitem": "item_width"
    },
    "path": [
      "size",
      "width",
      "logo_group",
      "item_width"
    ]
  },
  "size-square-avatar-small": {
    "value": "1.953125em",
    "filePath": "src/tokens/size/sizing.js",
    "isSource": true,
    "original": {
      "value": "1.953125em"
    },
    "name": "size-square-avatar-small",
    "attributes": {
      "category": "size",
      "type": "square",
      "item": "avatar",
      "subitem": "small"
    },
    "path": [
      "size",
      "square",
      "avatar",
      "small"
    ]
  },
  "size-square-avatar-medium": {
    "value": "3.0517578125em",
    "filePath": "src/tokens/size/sizing.js",
    "isSource": true,
    "original": {
      "value": "3.0517578125em"
    },
    "name": "size-square-avatar-medium",
    "attributes": {
      "category": "size",
      "type": "square",
      "item": "avatar",
      "subitem": "medium"
    },
    "path": [
      "size",
      "square",
      "avatar",
      "medium"
    ]
  },
  "size-square-avatar-large": {
    "value": "11.641532182693481em",
    "filePath": "src/tokens/size/sizing.js",
    "isSource": true,
    "original": {
      "value": "11.641532182693481em"
    },
    "name": "size-square-avatar-large",
    "attributes": {
      "category": "size",
      "type": "square",
      "item": "avatar",
      "subitem": "large"
    },
    "path": [
      "size",
      "square",
      "avatar",
      "large"
    ]
  },
  "size-square-avatar-full": {
    "value": "100%",
    "filePath": "src/tokens/size/sizing.js",
    "isSource": true,
    "original": {
      "value": "100%"
    },
    "name": "size-square-avatar-full",
    "attributes": {
      "category": "size",
      "type": "square",
      "item": "avatar",
      "subitem": "full"
    },
    "path": [
      "size",
      "square",
      "avatar",
      "full"
    ]
  },
  "size-square-control-icon": {
    "value": "1em",
    "filePath": "src/tokens/size/sizing.js",
    "isSource": true,
    "original": {
      "value": "1em"
    },
    "name": "size-square-control-icon",
    "attributes": {
      "category": "size",
      "type": "square",
      "item": "control",
      "subitem": "icon"
    },
    "path": [
      "size",
      "square",
      "control",
      "icon"
    ]
  },
  "size-square-toggle-medium": {
    "value": "1.5625em",
    "filePath": "src/tokens/size/sizing.js",
    "isSource": true,
    "original": {
      "value": "1.5625em"
    },
    "name": "size-square-toggle-medium",
    "attributes": {
      "category": "size",
      "type": "square",
      "item": "toggle",
      "subitem": "medium"
    },
    "path": [
      "size",
      "square",
      "toggle",
      "medium"
    ]
  },
  "size-square-footnote-link": {
    "value": "1.5625em",
    "filePath": "src/tokens/size/sizing.js",
    "isSource": true,
    "original": {
      "value": "1.5625em"
    },
    "name": "size-square-footnote-link",
    "attributes": {
      "category": "size",
      "type": "square",
      "item": "footnote_link"
    },
    "path": [
      "size",
      "square",
      "footnote_link"
    ]
  },
  "size-overlap-small": {
    "value": "0.262144em",
    "comment": "Small amount of overlap between adjacent items organized in a visual bunch.",
    "filePath": "src/tokens/size/sizing.js",
    "isSource": true,
    "original": {
      "value": "0.262144em",
      "comment": "Small amount of overlap between adjacent items organized in a visual bunch."
    },
    "name": "size-overlap-small",
    "attributes": {
      "category": "size",
      "type": "overlap",
      "item": "small"
    },
    "path": [
      "size",
      "overlap",
      "small"
    ]
  },
  "size-spacing-gap-button-extra": {
    "value": "0.40959999999999996em",
    "comment": "Gap between button content and extra content.",
    "filePath": "src/tokens/size/spacing.js",
    "isSource": true,
    "original": {
      "value": "0.40959999999999996em",
      "comment": "Gap between button content and extra content."
    },
    "name": "size-spacing-gap-button-extra",
    "attributes": {
      "category": "size",
      "type": "spacing",
      "item": "gap",
      "subitem": "button",
      "state": "extra"
    },
    "path": [
      "size",
      "spacing",
      "gap",
      "button",
      "extra"
    ]
  },
  "size-spacing-gap-inline-small": {
    "value": "1em",
    "comment": "Horizontal/column gap between media object and content, etc.",
    "filePath": "src/tokens/size/spacing.js",
    "isSource": true,
    "original": {
      "value": "1em",
      "comment": "Horizontal/column gap between media object and content, etc."
    },
    "name": "size-spacing-gap-inline-small",
    "attributes": {
      "category": "size",
      "type": "spacing",
      "item": "gap",
      "subitem": "inline",
      "state": "small"
    },
    "path": [
      "size",
      "spacing",
      "gap",
      "inline",
      "small"
    ]
  },
  "size-spacing-gap-inline-medium": {
    "value": "1.25em",
    "comment": "Horizontal/column gap between cells in inline lists, event logs, etc.",
    "filePath": "src/tokens/size/spacing.js",
    "isSource": true,
    "original": {
      "value": "1.25em",
      "comment": "Horizontal/column gap between cells in inline lists, event logs, etc."
    },
    "name": "size-spacing-gap-inline-medium",
    "attributes": {
      "category": "size",
      "type": "spacing",
      "item": "gap",
      "subitem": "inline",
      "state": "medium"
    },
    "path": [
      "size",
      "spacing",
      "gap",
      "inline",
      "medium"
    ]
  },
  "size-spacing-gap-fluid-min": {
    "value": "1.953125em",
    "comment": "Minimum size of a large content gap, for example gutters between cards.",
    "filePath": "src/tokens/size/spacing.js",
    "isSource": true,
    "original": {
      "value": "1.953125em",
      "comment": "Minimum size of a large content gap, for example gutters between cards."
    },
    "name": "size-spacing-gap-fluid-min",
    "attributes": {
      "category": "size",
      "type": "spacing",
      "item": "gap",
      "subitem": "fluid",
      "state": "min"
    },
    "path": [
      "size",
      "spacing",
      "gap",
      "fluid",
      "min"
    ]
  },
  "size-spacing-gap-fluid-max": {
    "value": "3.814697265625em",
    "comment": "Maximum size of a large content gap, for example gutters between cards.",
    "filePath": "src/tokens/size/spacing.js",
    "isSource": true,
    "original": {
      "value": "3.814697265625em",
      "comment": "Maximum size of a large content gap, for example gutters between cards."
    },
    "name": "size-spacing-gap-fluid-max",
    "attributes": {
      "category": "size",
      "type": "spacing",
      "item": "gap",
      "subitem": "fluid",
      "state": "max"
    },
    "path": [
      "size",
      "spacing",
      "gap",
      "fluid",
      "max"
    ]
  },
  "size-spacing-gap-button-group-default": {
    "value": "0.64em",
    "comment": "The Button Group default gap spacing.",
    "filePath": "src/tokens/size/spacing.js",
    "isSource": true,
    "original": {
      "value": "0.64em",
      "comment": "The Button Group default gap spacing."
    },
    "name": "size-spacing-gap-button-group-default",
    "attributes": {
      "category": "size",
      "type": "spacing",
      "item": "gap",
      "subitem": "button_group",
      "state": "default"
    },
    "path": [
      "size",
      "spacing",
      "gap",
      "button_group",
      "default"
    ]
  },
  "size-spacing-gap-form-group-default": {
    "value": "0.32767999999999997em",
    "comment": "The Form Group default gap spacing.",
    "filePath": "src/tokens/size/spacing.js",
    "isSource": true,
    "original": {
      "value": "0.32767999999999997em",
      "comment": "The Form Group default gap spacing."
    },
    "name": "size-spacing-gap-form-group-default",
    "attributes": {
      "category": "size",
      "type": "spacing",
      "item": "gap",
      "subitem": "form_group",
      "state": "default"
    },
    "path": [
      "size",
      "spacing",
      "gap",
      "form_group",
      "default"
    ]
  },
  "size-spacing-gap-logo-group": {
    "value": "1.953125em",
    "filePath": "src/tokens/size/spacing.js",
    "isSource": true,
    "original": {
      "value": "1.953125em"
    },
    "name": "size-spacing-gap-logo-group",
    "attributes": {
      "category": "size",
      "type": "spacing",
      "item": "gap",
      "subitem": "logo_group"
    },
    "path": [
      "size",
      "spacing",
      "gap",
      "logo_group"
    ]
  },
  "size-spacing-gap-comment-form-horizontal": {
    "value": "2.44140625rem",
    "filePath": "src/tokens/size/spacing.js",
    "isSource": true,
    "original": {
      "value": "2.44140625rem"
    },
    "name": "size-spacing-gap-comment-form-horizontal",
    "attributes": {
      "category": "size",
      "type": "spacing",
      "item": "gap",
      "subitem": "comment_form",
      "state": "horizontal"
    },
    "path": [
      "size",
      "spacing",
      "gap",
      "comment_form",
      "horizontal"
    ]
  },
  "size-spacing-gap-comment-form-vertical": {
    "value": "1.5625rem",
    "filePath": "src/tokens/size/spacing.js",
    "isSource": true,
    "original": {
      "value": "1.5625rem"
    },
    "name": "size-spacing-gap-comment-form-vertical",
    "attributes": {
      "category": "size",
      "type": "spacing",
      "item": "gap",
      "subitem": "comment_form",
      "state": "vertical"
    },
    "path": [
      "size",
      "spacing",
      "gap",
      "comment_form",
      "vertical"
    ]
  },
  "size-spacing-control-text-inset": {
    "value": "0.8em",
    "filePath": "src/tokens/size/spacing.js",
    "isSource": true,
    "original": {
      "value": "0.8em"
    },
    "name": "size-spacing-control-text-inset",
    "attributes": {
      "category": "size",
      "type": "spacing",
      "item": "control",
      "subitem": "text_inset"
    },
    "path": [
      "size",
      "spacing",
      "control",
      "text_inset"
    ]
  },
  "size-spacing-control-icon-inset": {
    "value": "0.512em",
    "filePath": "src/tokens/size/spacing.js",
    "isSource": true,
    "original": {
      "value": "0.512em"
    },
    "name": "size-spacing-control-icon-inset",
    "attributes": {
      "category": "size",
      "type": "spacing",
      "item": "control",
      "subitem": "icon_inset"
    },
    "path": [
      "size",
      "spacing",
      "control",
      "icon_inset"
    ]
  },
  "size-spacing-type-block-indent": {
    "value": "1.25em",
    "comment": "Shared indentation for lists, blockquotes, etc.",
    "filePath": "src/tokens/size/spacing.js",
    "isSource": true,
    "original": {
      "value": "{size.spacing.gap.inline.medium.value}",
      "comment": "Shared indentation for lists, blockquotes, etc."
    },
    "name": "size-spacing-type-block-indent",
    "attributes": {
      "category": "size",
      "type": "spacing",
      "item": "type",
      "subitem": "block_indent"
    },
    "path": [
      "size",
      "spacing",
      "type",
      "block_indent"
    ]
  },
  "size-spacing-list-inline-gap": {
    "value": "1.25em",
    "filePath": "src/tokens/size/spacing.js",
    "isSource": true,
    "original": {
      "value": "{size.spacing.gap.inline.medium.value}"
    },
    "name": "size-spacing-list-inline-gap",
    "attributes": {
      "category": "size",
      "type": "spacing",
      "item": "list",
      "subitem": "inline_gap"
    },
    "path": [
      "size",
      "spacing",
      "list",
      "inline_gap"
    ]
  },
  "size-spacing-media-gap": {
    "value": "1em",
    "filePath": "src/tokens/size/spacing.js",
    "isSource": true,
    "original": {
      "value": "{size.spacing.gap.inline.small.value}"
    },
    "name": "size-spacing-media-gap",
    "attributes": {
      "category": "size",
      "type": "spacing",
      "item": "media",
      "subitem": "gap"
    },
    "path": [
      "size",
      "spacing",
      "media",
      "gap"
    ]
  }
}